import { guidEmpty } from "utils/guid-empty";
import { EnumTipoContato } from "../../../../models/enums/enum-tipo-contato";
import { EnumIndIEDest } from "models/enums/enum-indiedest";

export enum EnumSexo {
    NaoInformado,
    Masculino,
    Feminino
}

export class PessoaModel {
    constructor(
        public id: string = guidEmpty(),
        public contratoId: string = guidEmpty(),
        public regimeTributarioId: string = guidEmpty(),
        public tabelaPrecoId: string = guidEmpty(),
        public representanteId: string = guidEmpty(),
        public tpCadastro: number = 2,
        public cpfcnpj: string = '',
        public ierg: string = '',
        public im: string = '',
        public indIEDest: number = 9,
        public nome: string = '',
        public fantasia: string = '',
        public infOperador: string = '',
        public infInterno: string = '',
        public status: number = 0,
        public sexo: EnumSexo = EnumSexo.NaoInformado,
        public contatos: ContatoModel[] = [],
        public dtNasc: string = '',
        public enderecos: Array<PessoaEnderecoModel> = []
    ) { }
}

export class ContatoModel {
    constructor(
        public id: string | null = null,
        public pessoaId: string | null = null,
        public tipo: EnumTipoContato = EnumTipoContato.TELEFONE,
        public valor: string = '',
    ) { }
}

export class PessoaEnderecoModel {
    constructor(
        public id: string = guidEmpty(),
        public pessoaId: string = guidEmpty(), //IdPessoa
        public cep: string = '',
        public logradouro: string = '',
        public numero: string = '',
        public complemento: string = '',
        public referencia: string = '',
        public bairro: string = '',
        public cMun: string = '',
        public xMun: string = '',
        public uf: string = '',
        public cuf: number = 0,
        public ierg: string = '',
        public im: string = '',
        public indIEDest: EnumIndIEDest = EnumIndIEDest.NAO_CONTRIBUINTE,
        public pessoaTransportadoraPadraoId: string = ''
    ) { }
}


export class PessoaModelForm {
    constructor(
        public nome: string = '',
        public cpfcnpj: string = '',
        public telefone: string = '',
        public email: string = '',
        public dtNasc: string = '',
        public sexo: EnumSexo = EnumSexo.NaoInformado
    ) { }
}